import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ProfileMetadata } from '../../types/user/userProfile'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export const useProfileMetadata = () => {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const { authInfo } = useAuth()
  const { fetcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
  }

  const profileMetadata = async (
    profileId: string
  ): Promise<ProfileMetadata | null> => {
    setLoading(true)
    setError(null)

    try {
      return await fetcher<ProfileMetadata>(
        `${CONFIG.BOUNCE_API}/api/v1/profiles/${encodeURIComponent(profileId)}`
      )
    } catch (caughtError) {
      console.error(caughtError)

      if (caughtError instanceof ApiError) {
        setError(getErrorMessage(caughtError.data))
      } else {
        setError(t('unknown'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  return {
    profileMetadata,
    loading,
    error,
    resetState,
  }
}
